import React from 'react';
import './resume.scss';
import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';
import resumeData from '../../data/resume.json';
import { ResumeData } from './resumetypes';

const experienceSection = (resumeData as ResumeData).sections.find(
  section => section.title === 'Experience'
);

const experienceData = experienceSection?.entries ?? [];

const Resume: React.FC = () => {
  return (
    <section className="resume-container" id="resume">
      <h2 className="resume-title">{experienceSection?.title ?? 'Experience'}</h2>
      
      <div className="timeline-wrapper">
        <div className="center-line"></div>

        {experienceData.map((exp, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? 'right' : 'left'} ${exp.current ? 'current-role' : ''}`}
          >
            <div className="timeline-marker" aria-hidden="true">
              <FaBriefcase />
            </div>

            <div className="timeline-card">
              <div className="card-header">
  <div className="header-left">
    <div className="title-row">
      <h3 className="job-title">{exp.title}</h3>
      {exp.current && <span className="current-badge">Current</span>}
    </div>
    <span className="company-name">{exp.company}</span>
  </div>

  <div className="header-right">
    <span><FaCalendarAlt /> {exp.dates}</span>
  </div>
</div>
              
              {exp.bulletPoints && (
                <ul className="job-description">
                  {exp.bulletPoints.map((bulletPoint) => (
                    <li key={bulletPoint}>{bulletPoint}</li>
                  ))}
                </ul>
              )}

              {exp.highlights && (
                <div className="experience-highlights">
                  {exp.highlights.map((highlight) => (
                    <span key={highlight} className="highlight-chip">{highlight}</span>
                  ))}
                </div>
              )}
              
              
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Resume;
